import { Container, Grid, Typography, Link, IconButton } from '@mui/material'

const Footer = () => {
  return (
    <footer className="footer-section pad-60">
      <Container>
        <Grid container spacing={4}>
          {/* First Column: Logo and Tags */}
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <div className="footer-logo">
              <img src="/branding/e7_logo_white.png" alt="Epoch7 Logo" style={{ width: '120px' }} />
            </div>
          </Grid>

          {/* Second Column: Navigation Links */}
          <Grid item lg={4} md={6} sm={12} xs={12}>
            <Typography variant="h5" gutterBottom>
              Quick Links
            </Typography>
            <ul className="footer-links" style={{ listStyle: 'none', padding: 0 }}>
              <li className="mb-2">
                <Link href="#home" underline="hover">
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link href="#about" underline="hover">
                  Product
                </Link>
              </li>
              <li className="mb-2">
                <Link href="#services" underline="hover">
                  Services
                </Link>
              </li>
              <li className="mb-2">
                <Link href="#contact" underline="hover">
                  Contact Us
                </Link>
              </li>
            </ul>
          </Grid>

          {/* Third Column: Contact Info */}
          <Grid item lg={4} md={6} sm={12}>
            <Typography variant="h5" gutterBottom>
              Contact Us
            </Typography>
            <div className="footer-contact">
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex' }}>
                <li style={{ marginRight: '10px' }}>
                  <IconButton
                    component="a"
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/document-templates/facebook.svg"
                      alt="Facebook"
                      style={{ width: '50px', height: '50px' }}
                    />
                  </IconButton>
                </li>
                <li style={{ marginRight: '10px' }}>
                  <IconButton
                    component="a"
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/document-templates/twiter.svg"
                      alt="Twitter"
                      style={{ width: '50px', height: '50px' }}
                    />
                  </IconButton>
                </li>
                <li>
                  <IconButton
                    component="a"
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/document-templates/linkedin.svg"
                      alt="LinkedIn"
                      style={{ width: '50px', height: '50px' }}
                    />
                  </IconButton>
                </li>
              </ul>
            </div>
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Grid container spacing={0} justifyContent="center" style={{ marginTop: '20px' }}>
          <Grid item>
            <Typography variant="body2" align="center">
              &copy; 2024 epoch7.io. All Rights Reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </footer>
  )
}

export default Footer
